import {Directive, HostListener} from "@angular/core";

declare var jQuery : any;

@Directive({
    selector: '[dp-table-commands]'
})

export class DpTableCommands {


    constructor() {
    }

    @HostListener('keydown', ['$event']) onKeydownHandler(event: KeyboardEvent): void {
        this.tableKeyCommands(event);
    }

    ngOnInit(){

    }


    tableKeyCommands(event) : void {
        let charCode = (event.charCode) ? event.charCode : ((event.keyCode) ? event.keyCode : ((event.which) ? event.which : 0));
        if(charCode === 9 &&  !jQuery(event.target).closest('tr').is(":last-child") && !event.shiftKey) {
            event.preventDefault();
            if( jQuery(event.target).closest('tr').hasClass('expandable-element-row')){
                jQuery(event.target).closest('tr').next().next().focus();
            }
            else{
                jQuery(event.target).closest('tr').next().focus();
            }

        }
        if(charCode === 40) {

            if( jQuery(event.target).closest('tr').hasClass('expandable-element-row')){
                jQuery(event.target).closest('tr').next().next().focus();
            }
            else{
                jQuery(event.target).closest('tr').next().focus();
            }
        }
        if(charCode === 38) {
            if( jQuery(event.target).closest('tr').hasClass('expandable-element-row')){
                jQuery(event.target).closest('tr').prev().prev().focus();
            }
            else{
                jQuery(event.target).closest('tr').prev().focus();
            }
        }
    }

}
